<template>
  <div class="function-detail-panel">
    <label class="section-label">{{ selectedFunction.name || '函数说明' }}</label>
    <div class="function-detail-content">
      <div v-if="selectedFunction" class="function-detail">
        <div class="function-syntax">{{ selectedFunction.syntax }}</div>
        <div class="function-description">{{ selectedFunction.description }}</div>
        <div v-if="selectedFunction.example" class="function-example">
          <div class="example-label">示例：</div>
          <div class="example-content">{{ selectedFunction.example }}</div>
        </div>
      </div>
      <div v-else class="no-selection">选择一个函数查看详细说明</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FunctionDetail',

  props: {
    selectedFunction: {
      type: Object,
      default: () => {}
    }
  }
}
</script>

<style lang="scss" scoped>
.function-detail-panel {
  .section-label {
    display: block;
    margin-bottom: 8px;
    font-weight: 500;
    color: #333;
  }

  .function-detail-content {
    background: #fff;
    border-radius: 4px;
    padding: 15px;
    min-height: 150px;

    .function-syntax {
      font-family: monospace;
      color: #007bff;
      margin-bottom: 10px;
      padding: 8px;
      background: #f0f9ff;
      border-radius: 4px;
    }

    .function-description {
      color: #606266;
      line-height: 1.5;
      margin-bottom: 15px;
    }

    .function-example {
      margin-top: 15px;
      padding-top: 15px;
      border-top: 1px solid #e4e7ed;

      .example-label {
        font-weight: 500;
        color: #303133;
        margin-bottom: 5px;
      }

      .example-content {
        color: #606266;
        line-height: 1.6;
        font-family: monospace;
        background: #f5f7fa;
        padding: 10px;
        border-radius: 4px;
        white-space: pre-wrap;
      }
    }

    .no-selection {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 150px;
      color: #909399;
    }
  }
}
</style>